import { EventSelectionDropdownWrapper } from "../../styled/styled";
import EventDropdown from "../../eventDropdown/EventDropdown";
import EventList from "../../eventList/EventList";
import React from "react";
import { EventAutocompleteOption } from "../../../globalSettings/types";
import { ClickAwayListener } from '@mui/base/ClickAwayListener';

type Props = {
  isButtonClicked: boolean;
  onDropdownClick: () => void;
  isFormDisabled: boolean;
  selectedOption?: EventAutocompleteOption;
  options: EventAutocompleteOption[];
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onSelect: (item: string) => void;
  filteredOptions: EventAutocompleteOption[];
  onClickAway: () => void;
}

export const EventSelector = ({ onClickAway, onDropdownClick, isButtonClicked, isFormDisabled, selectedOption, options, onSelect, filteredOptions, onChange }: Props) => {
  return (
    <ClickAwayListener onClickAway={onClickAway}>
     <EventSelectionDropdownWrapper>
       <div className={'select-box-dropdown'} data-testid="event-select-box-dropdown">
         <EventDropdown
           disabled={isFormDisabled}
           isButtonClicked={isButtonClicked}
           selectedOption={selectedOption}
           onDropdownClick={onDropdownClick}
         />
         {isButtonClicked && options && (
           <EventList
             options={filteredOptions}
             onChange={onChange}
             onSelect={onSelect}
           />
         )}
       </div>
     </EventSelectionDropdownWrapper>
    </ClickAwayListener>
  );
};